// Generated by ReScript, PLEASE EDIT WITH CARE


var selectRole = {
  id: "a0502347-9668-4ccf-b444-f9fabd234645",
  defaultMessage: "Choose a role"
};

var administratorFrance = {
  id: "66086f8a-eb4c-4872-978c-a76dcb30b8b7",
  defaultMessage: "Administrator"
};

var administratorFranceProd = {
  id: "bc0198eb-ec11-4b47-8542-8786b942596e",
  defaultMessage: "Administrator"
};

var administratorSpain = {
  id: "be3494a0-01a1-462a-b279-bfe112f266c7",
  defaultMessage: "Administrator (ES)"
};

var advisor = {
  id: "f52d5116-f621-42da-9c16-36b15c8f7a5b",
  defaultMessage: "Quotation Platform Advisor"
};

var preDirector = {
  id: "2b7f318f-a114-45b8-99dc-975ae242d3dc",
  defaultMessage: "PRE Director"
};

var companyManager = {
  id: "d3e41a32-286f-43f6-92c0-978cfc441a86",
  defaultMessage: "Com. manager"
};

var seniorCompanyManager = {
  id: "8bd9f65c-8f2f-4c64-844a-46c7388bfc47",
  defaultMessage: "Senior company manager"
};

var acountManager = {
  id: "1653dc99-5e21-443f-857a-fe2e0df04951",
  defaultMessage: "Account manager"
};

var lldManager = {
  id: "14040f61-f1c2-45d9-be00-845c8c37e415",
  defaultMessage: "Senior LLD Manager + LLD Manager"
};

var bigAccountManager = {
  id: "a76ca43e-16db-465b-810a-5d5fb6e97fbd",
  defaultMessage: "Big account manager"
};

var dealer = {
  id: "55517275-85ff-4ef0-88c8-7b778a194873",
  defaultMessage: "Dealer"
};

var noRole = {
  id: "e825102d-c62b-4d95-9046-a5cc458b8615",
  defaultMessage: "No role"
};

var adminDealerFR = {
  id: "57ef4140-9eda-45df-b365-f8cc803d51e0",
  defaultMessage: "Dealer (for admin only)"
};

var adminDealerES = {
  id: "98a59e5b-ce08-4655-84fb-662a7e981ca4",
  defaultMessage: "Dealer ES (For admin only)"
};

var mrr = {
  id: "c86bbe21-4692-4046-91fa-326a8215e7f5",
  defaultMessage: "Network Manager"
};

var rmpc = {
  id: "615e6ac9-f931-49a7-a94f-ae97e554fd14",
  defaultMessage: "RMPC/DT"
};

var dpr = {
  id: "a8500c98-6144-463e-ad05-3c8bb6802e5a",
  defaultMessage: "DPR"
};

export {
  selectRole ,
  administratorFrance ,
  administratorFranceProd ,
  administratorSpain ,
  advisor ,
  preDirector ,
  companyManager ,
  seniorCompanyManager ,
  acountManager ,
  lldManager ,
  bigAccountManager ,
  dealer ,
  noRole ,
  adminDealerFR ,
  adminDealerES ,
  mrr ,
  rmpc ,
  dpr ,
}
/* No side effect */
